import {ColumnPropertyLazySelect} from "../../../../../../../core/types/records-table.types";

export const placePropertyLazySelect: ColumnPropertyLazySelect = {
  recourseName: 'StorageLocationType',
  providerType: 'DEFAULT'
}

export const articleWBPropertyLazySelect: ColumnPropertyLazySelect = {
  recourseName: 'ProductPackageDto',
  providerType: 'PRODUCT_PACKAGE_WILDBERRIES_ARTICLES'
}

export const articleOzonPropertyLazySelect: ColumnPropertyLazySelect = {
  recourseName: 'ProductPackageDto',
  providerType: 'PRODUCT_PACKAGE_OZON_ARTICLES'
}
